const CancellationAndRefunds = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_3934_54475)">
      <path
        d="M9.79375 19.4844C9.79375 19.4844 17.0875 15.8375 17.0875 10.3672V3.98516L9.79375 1.25L2.5 3.98516L2.5 10.3672C2.5 15.8375 9.79375 19.4844 9.79375 19.4844Z"
        stroke="#444444"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.375 6.875L8.98438 13.8194L6.25 10.947"
        stroke="#444444"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3934_54475">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CancellationAndRefunds;
